import React from 'react'
import drrajkishoresarkar from "../images/rajkishore sarkar.png";

function About() {
  return (
    <div>
         <div className="album py-0">
          <div className="container">
            <div className="row ">
              <div className="col-md-5 mt-3">
         <img src={drrajkishoresarkar} className="img-fluid " alt="drrajkishoresarkar" />

                </div>
                <div className="col-md-6 mt-3" >
                  <h6 style={{color:"#089898"}}>About Dr. Rajkishore Sarkar </h6>
                  <h1  className='abouthead' style={{color:"#08177b"}}>Orthopedic Surgeon & Joint Replacement Specialist</h1>
                  <p style={{color:"#06568f"}}>Dr. Rajkishore Sarkar is a qualified Orthopaedic Surgeon with an MBBS and MS in Orthopaedics from Kolkata National Medical College & Hospital. He is a Consultant Orthopaedic Surgeon dedicated to providing comprehensive diagnosis, treatment and management of various bone, joint, muscle and musculoskeletal conditions.</p>
                  <p style={{color:"#06568f"}}>With a patient-focused approach, Dr. Rajkishore Sarkar provides consultation and treatment for a wide range of orthopaedic problems, joint pain, bone and muscle disorders, sports injuries, arthritis and other musculoskeletal conditions.</p>
                  <h6 style={{color:"#898080"}}><b>Qualifications: </b>MBBS, MS (Orthopaedics)</h6>
                   <h6 style={{color:"#898080"}}><b>Specialization: </b>Orthopaedic Surgery</h6>

                    <h6 style={{color:"#898080"}}><b>Designation:  </b>Consultant Orthopaedic Surgeon</h6>
                    
                    <h6 style={{color:"#898080"}}><b>Medical Registration No.:  </b>58624 (WBMC)</h6>
                    
                    <h6 style={{color:"#898080"}}><b>Medical College:   </b>Kolkata National Medical College & Hospital</h6>
                </div>
                </div>
                </div>
                </div>
    </div>
  )
}

export default About